import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = {
  key: 1,
  class: ""
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "clm-act-cntn" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderCustom = _resolveComponent("HeaderCustom")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!
  const _component_HjpDefaultModal = _resolveComponent("HjpDefaultModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_HeaderCustom, {
            titleHeader: _ctx.headerTitle,
            titleButton: _ctx.buttonTitle,
            onRedirectAdd: _ctx.onClickBtnAdd,
            placeholder: _ctx.searchPlaceholder,
            onOnSearch: _ctx.onSearch,
            showSearch: _ctx.showSearch,
            showAddBtn: _ctx.showBtnAdd
          }, null, 8, ["titleHeader", "titleButton", "onRedirectAdd", "placeholder", "onOnSearch", "showSearch", "showAddBtn"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          id: "hjp-data-table",
          value: _ctx.dataSource,
          paginator: false,
          loading: _ctx.isLoading,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll",
          onSort: _ctx.onSort
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_EmptyState, { textNoData: _ctx.emptyTable }, null, 8, ["textNoData"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            (_ctx.columns.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.columns, (col, index) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    key: index,
                    field: col.field,
                    header: col.headerName,
                    hidden: col?.visible,
                    sortable: col.sortable,
                    class: _normalizeClass(col?.class),
                    style: _normalizeStyle(col?.style)
                  }, {
                    body: _withCtx((slotProps) => [
                      (col.isRender)
                        ? _renderSlot(_ctx.$slots, col.field, {
                            key: 0,
                            slotProps: slotProps
                          })
                        : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.get(slotProps.data, col.field)), 1))
                    ]),
                    _: 2
                  }, 1032, ["field", "header", "hidden", "sortable", "class", "style"]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.showColumnActivate)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 1,
                  header: "Aktif"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_InputSwitch, {
                        modelValue: slotProps.data.IsActive,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.IsActive) = $event),
                        onChange: ($event: any) => (_ctx.changeIsActive(slotProps.data))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showAction)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 2,
                  class: "colom-action mx-auto",
                  header: "Aksi"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "px-4 py-2 flex items-center cursor-pointer rounded-lg background-grey-lighten-5",
                        onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
                      }, _hoisted_8, 8, _hoisted_5)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["value", "loading", "onSort"]),
        _createVNode(_component_OverlayPanel, { ref: "refOverlayAction" }, {
          default: _withCtx(() => [
            _createVNode(_component_ListActions, {
              edit: _ctx.isEdit,
              del: _ctx.isDelete,
              change: _ctx.isChangeForm,
              editTitle: _ctx.editTitle,
              changeTitle: _ctx.changeTitle,
              delTitle: _ctx.delTitle,
              onDel: _ctx.onDelete,
              onEdit: _ctx.onEdit,
              onChange: _ctx.onChange
            }, null, 8, ["edit", "del", "change", "editTitle", "changeTitle", "delTitle", "onDel", "onEdit", "onChange"])
          ]),
          _: 1
        }, 512)
      ]),
      footer: _withCtx(() => [
        (_ctx.paginate.totalRecords > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.paginate.pageSize,
              totalRecords: _ctx.paginate.totalRecords,
              onOnPage: _ctx.onChangePage
            }, null, 8, ["rows", "totalRecords", "onOnPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode(_component_HjpSideBar, {
      show: _ctx.showModalForm,
      onHideDialog: _ctx.hideModalForm,
      confirmDialogDelete: _ctx.confirmDialogDelete,
      canDelete: _ctx.sidebarCanDelete,
      onOnDelete: _ctx.submitFromDialog
    }, _createSlots({ _: 2 }, [
      (_ctx.showModalForm)
        ? {
            name: "form",
            fn: _withCtx(() => [
              (_ctx.formIndex === 1)
                ? _renderSlot(_ctx.$slots, "secondform", { key: 0 })
                : _renderSlot(_ctx.$slots, "form", { key: 1 })
            ])
          }
        : undefined
    ]), 1032, ["show", "onHideDialog", "confirmDialogDelete", "canDelete", "onOnDelete"]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.showConfirmDialog,
      title: _ctx.confirmDialogDelete?.title,
      subTitle: _ctx.confirmDialogDelete?.subTitle,
      btnSubmitTitle: _ctx.confirmDialogDelete?.btnSubmitTitle,
      imgContent: _ctx.confirmDialogDelete.imgContent,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.submitFromDialog
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"]),
    _createVNode(_component_HjpDefaultModal, {
      show: _ctx.showDialogForm,
      onHideDialog: _ctx.hideDialogForm
    }, {
      content: _withCtx(() => [
        _renderSlot(_ctx.$slots, "customDialog")
      ]),
      _: 3
    }, 8, ["show", "onHideDialog"])
  ]))
}